/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export const NOTARY_ASSIGNABLE_PARTICIPANT_TITLES = [
  'Non-Borrowing Owner',
  'Third Party Recipient',
  'Power of Attorney',
  'Guardian',
  'Realtor',
  'Attorney',
  'Settlement Agent',
  'Trustee',
  'Loan Officer',
  'Witness',
  'Other',
];

export const ECLOSE_BORROWER_TITLES = ['Borrower', 'Co-Borrower', 'Primary Borrower'];
